var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconclose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.152 18.736L20 13.12L12.848 18.736C12.752 18.8107 12.6347 18.848 12.496 18.848C12.3573 18.848 12.24 18.8107 12.144 18.736C12.048 18.6613 12 18.5707 12 18.464C12 18.3467 12.048 18.2507 12.144 18.176L20 12L27.856 18.176C27.952 18.2507 28 18.3467 28 18.464C28 18.5707 27.952 18.6613 27.856 18.736C27.76 18.8107 27.6427 18.848 27.504 18.848C27.3653 18.848 27.248 18.8107 27.152 18.736ZM12.848 21.264L20 26.88L27.152 21.264C27.248 21.1787 27.3653 21.136 27.504 21.136C27.6427 21.136 27.76 21.1787 27.856 21.264C27.952 21.3387 28 21.4293 28 21.536C28 21.6427 27.952 21.7333 27.856 21.808L20 28L12.144 21.808C12.048 21.7333 12 21.6427 12 21.536C12 21.4293 12.048 21.3387 12.144 21.264C12.24 21.1787 12.3573 21.136 12.496 21.136C12.6347 21.136 12.752 21.1787 12.848 21.264Z",
    fill: "#415385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconclose);
export default __webpack_public_path__ + "static/media/iconclose.be2a14437dbcdce6ab8d97dc6feabd18.svg";
export { ForwardRef as ReactComponent };